// src/composables/useGlobal.ts
import { ref } from "vue";
import dayjs from "dayjs";
import router from "@/router/index";
import { useGlobal } from "@/composables/global/useGlobal";

import Swal from "sweetalert2";
import i18n from "@/i18n/index";

import type { ManipulateType } from "dayjs";
export function useLabel() {
  const { formatDate } = useGlobal();

  const getSubscriptionEndDateLabel = (subscription: any) => {
    if (!subscription) return "";

    if (subscription.is_paused) return "*************";

    return subscription.end_date ? formatDate(subscription.end_date) : "-";
  };
  const formatSubscriptionRemainingDays = (subscription: any) => {
    if (!subscription) return "";

    if (subscription.is_paused) return "*************";

    const days = subscription.status?.remaining_days ?? 0;

    return `${days} ${i18n.t("symbole.day")}`;
  };

  interface ImageValidationResult {
  status: 'good' | 'warning' | 'error';
  message: string;
  cssClass: string;
}

  const validerImage = (pathImage: string): ImageValidationResult => {
    if (!pathImage) {
      return {
        status: "warning",
        message: "Image inexistante.",
        cssClass: "img-warning",
      };
    }

    const extension = pathImage.split(".").pop()?.toLowerCase();

    if (extension === "webp") {
      return {
        status: "error",
        message:
          "Format .webp non supporté par la pointeuse (utilisez .jpg ou .png).",
        cssClass: "img-danger",
      };
    }

    if (["jpg", "jpeg", "png"].includes(extension ?? "")) {
      return {
        status: "good",
        message: "Image compatible avec la pointeuse.",
        cssClass: "img-success",
      };
    }

    return {
      status: "error",
      message: "Format non supporté. Seuls .jpg et .png sont autorisés.",
      cssClass: "img-danger",
    };
  };

  return {
    validerImage,
    getSubscriptionEndDateLabel,
    formatSubscriptionRemainingDays,
  };
}
